<template>
  <div class="attribute">
    <div class="name" @click="open">
      {{ name }}<span class="counter" v-if="selection.length">{{ selection.length }}</span>
      <div class="open-terms">
        <span class="opened fi-rr-angle-small-down" v-if="opened"></span>
        <span class="closed fi-rr-angle-small-up" v-else></span>
      </div>
    </div>
    <div class="terms">
      <div class="terms-inner" v-if="opened">
        <ul>
          <li v-for="(option, index) in options" :class="{ 'hidden': (index >= limit && !showMore) }" :key="index" @click.stop="select(option)">
            <label>
              <span class="checkbox" :class="{ selected: isSelected(option), radio: !multiple }">
                <span class="checkmark"><span class="fi-rr-check"></span></span>
              </span>
              {{ option.name }}
            </label>
          </li>
        </ul>
        <div class="more-terms" v-if="options.length > limit && !showMore"><a href="" @click.prevent="showMore = true">+ Afficher plus</a></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Attribute',
  props: {
    type: String,
    name: String,
    multiple: Boolean,
    options: Array,
    selection: Array
  },
  data () {
    return {
      limit: 5,
      opened: false,
      showMore: false
    }
  },
  methods: {
    open () {
      this.opened = !this.opened
    },
    isSelected (option) {
      const index = this.selection.findIndex(item => item === option.value)
      return index !== -1;
    },
    select (option) {

      const selection = this.selection

      const index = selection.findIndex(item => item === option.value)
      if(index === -1) {
        selection.push(option.value)
      } else {
        selection.splice(index, 1)
      }

      if(!this.multiple) {
        selection.splice(0, selection.length)
        selection.push(option.value)
      }

      this.$emit('update', { type: this.type, selection: selection })

    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.attribute{
  border-bottom: 1px solid darken($white, 10%);

  .name {
    font-size: px2rem(14px);
    font-weight: $fontBold;
    height: 54px;
    line-height: 54px;
    position: relative;
    cursor: pointer;
    padding-right: 34px;

    span.counter{
      display: inline-block;
      min-width: 18px;
      height: 18px;
      vertical-align: middle;
      background-color: $primary;
      color: $white;
      font-weight: $fontSemiBold;
      padding: 0 5px;
      line-height: 20px;
      font-size: px2rem(12px);
      margin-left: 5px;
      text-align: center;
      @include box-sizing();
      @include radius(9px);
    }

    .open-terms{
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      width: auto;
      height: 100%;
      font-size: 22px;
      color: darken($white, 40%);

      span{
        display: inline-block;
        @include transform(translateY(-1px));
      }
    }
  }

  .terms {
    overflow: hidden;

    ul {
      padding-bottom: 20px;

      li {
        font-size: px2rem(13px);
        line-height: px2rem(19px);
        margin-bottom: 5px;
        position: relative;
        padding-left: 25px;

        &.hidden{
          display: none;
        }

        label {
          cursor: pointer;

          &:hover{
            span.checkbox span.checkmark{
              border: 1px solid darken($white, 40%);
            }
          }

          span.checkbox{
            width: 12px;
            height: 12px;
            position: absolute;
            top: 3px;
            left: 0;
            margin: 0 !important;

            &.radio{
              span.checkmark{
                @include radius(100%);
              }
            }

            &.selected {
              span.checkmark{
                border: 1px solid $primary;
                color: $white;
                background-color: $primary;
              }
            }

            span.checkmark{
              display: inline-block;
              width: 12px;
              height: 12px;
              background-color: $white;
              color: $white;
              border: 1px solid darken($white, 20%);
              @include radius(2px);
              @include transition();

              span{
                display: inline-block;
                font-size: 8px;
                font-weight: $fontBold;
                @include transform(translateY(-5px) translateX(2px));
              }
            }
          }
        }
      }
    }

    .more-terms{
      padding-left: 25px;
      padding-bottom: 5px;
      @include transform(translateY(-15px));

      a{
        font-size: 12px;
        color: darken($white, 40%);
        @include transition();

        &:hover{
          color: $primary;
        }
      }
    }
  }
}
</style>
